export const TEAM_MEMBER_CONNECTION_STATUSES = {
  pendingSignUpByUser: 'pending-sign-up-by-user',
  pendingEthAddressFromUser: 'pending-eth-address-from-user',
  pendingTransactionSigningByBoth: 'pending-transaction-signing-from-both',
  pendingTransactionSigningByUser: 'pending-transaction-signing-from-user',
  pendingTransactionSigningByCompany: 'pending-transaction-signing-from-company',
  signedByBoth: 'signed-by-both',
  rejectedByUser: 'rejected-by-user',
  unknown: 'unknown',
};

export function calculateTeamMemberConnectionStatus(teamMemberConnection) {
  if (teamMemberConnection) {
    // if (teamMemberConnection.status === 'verified')
    //   return TEAM_MEMBER_CONNECTION_STATUSES.signedByBoth;
    if (teamMemberConnection.rejectedTimestamp)
      return TEAM_MEMBER_CONNECTION_STATUSES.rejectedByUser;
    else if (teamMemberConnection.signedByUser && teamMemberConnection.signedByCompany)
      return TEAM_MEMBER_CONNECTION_STATUSES.signedByBoth;
    else if (!teamMemberConnection.user) return TEAM_MEMBER_CONNECTION_STATUSES.pendingSignUpByUser;
    else if (teamMemberConnection.user && !teamMemberConnection.user.ethereumAddress)
      return TEAM_MEMBER_CONNECTION_STATUSES.pendingEthAddressFromUser;
    else if (teamMemberConnection.user && teamMemberConnection.user.ethereumAddress) {
      if (
        typeof teamMemberConnection.signedByCompany === 'undefined' &&
        typeof teamMemberConnection.signedByUser === 'undefined'
      )
        return TEAM_MEMBER_CONNECTION_STATUSES.unknown;
      if (!teamMemberConnection.signedByCompany && !teamMemberConnection.signedByUser)
        return TEAM_MEMBER_CONNECTION_STATUSES.pendingTransactionSigningByBoth;
      else if (!teamMemberConnection.signedByCompany)
        return TEAM_MEMBER_CONNECTION_STATUSES.pendingTransactionSigningByCompany;
      else if (!teamMemberConnection.signedByUser)
        return TEAM_MEMBER_CONNECTION_STATUSES.pendingTransactionSigningByUser;
    }
    return TEAM_MEMBER_CONNECTION_STATUSES.unknown;
  }

  return undefined;
}



// WEBPACK FOOTER //
// ./src/store/features/company-team-member-connections/helpers.js